import React from 'react';

import Labels from '@/components/Blocks/Labels/Labels';

import './HeaderInfoComponent.scss';

export type HeaderInfoType = {
  tags?: {
    title: string;
  }[];
  author?: string;
  position?: string;
  date: string;
};

interface HeaderInfoProps {
  headerInfo: HeaderInfoType;
}

export const HeaderInfoComponent = ({ headerInfo }: HeaderInfoProps) => {
  const { tags, author, position, date } = headerInfo;

  return (
    <div className="HeaderInfo-wrapper">
      {tags && tags.length > 0 && (
        <div className="HeaderInfo-categories">
          <Labels
            items={tags.map((tag) => ({
              id: tag.title,
              title: tag.title,
            }))}
          />
        </div>
      )}
      <div className="HeaderInfo-author">
        <h6 className="HeaderInfo-author-name">{author}</h6>
        <div className="body-3 HeaderInfo-author-position">{position}</div>
      </div>
      <div className="body-3 HeaderInfo-date">{date}</div>
    </div>
  );
};
